import { render, staticRenderFns } from "./UserInfoModal.vue?vue&type=template&id=65ef1fcb"
import script from "./UserInfoModal.vue?vue&type=script&lang=js"
export * from "./UserInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports